import addMinutes from 'date-fns/addMinutes';
import format from 'date-fns/format';
import getMinutes from 'date-fns/getMinutes';
import parseISO from 'date-fns/parseISO';
import startOfHour from 'date-fns/startOfHour';
import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { SET_HOURS } from './types';
import { guidePropertiesSelector } from '../selectors/properties';

const guideSetHoursActionPayloadSchema = Joi.object().keys({
  hours: Joi.array().items(Joi.string()).sparse(false).required(),
  hoursStart: Joi.date().required(),
});

const guideSetHoursAction = actionCreator(SET_HOURS, guideSetHoursActionPayloadSchema);

const floorMinutesToHalfHour = (date) => {
  const minutes = getMinutes(date);
  const start = startOfHour(date);

  let roundedDate = date;
  if (minutes <= 29) {
    roundedDate = start;
  } else if (minutes <= 59) {
    roundedDate = addMinutes(start, 30);
  }

  return roundedDate;
};

const ceilMinutesToHalfHour = (date) => {
  const minutes = getMinutes(date);
  const start = startOfHour(date);

  let roundedDate = date;
  if (minutes % 30 > 0) {
    if (minutes <= 29) {
      roundedDate = addMinutes(start, 30);
    } else if (minutes <= 59) {
      roundedDate = addMinutes(start, 60);
    }
  }

  return roundedDate;
};

function* generateHours({ start, stop, formatString }) {
  let next = start;
  do {
    yield format(next, formatString, { locale: global.dateFnsLocale });
    next = addMinutes(next, 30);
  } while (stop >= next);
}

export const guideSetHoursThunkAction = ({ start, stop, formatString = 'p' }) => (
  dispatch,
  getState,
) => {
  let { hoursStart } = guidePropertiesSelector(getState());

  const parsedStart = typeof start === 'string' ? parseISO(start) : start;
  const parsedStop = typeof stop === 'string' ? parseISO(stop) : stop;

  // if type is string mean that it is the persisted value
  hoursStart = floorMinutesToHalfHour(parsedStart);

  const hours = [
    ...generateHours({
      start: hoursStart,
      stop: ceilMinutesToHalfHour(parsedStop),
      formatString,
    }),
  ];

  return dispatch(
    guideSetHoursAction({
      hours,
      hoursStart,
    }),
  );
};
